import React from 'react';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';
import { RootState } from '../../../../store';
import './../help-center.css';

interface IplaceOrderWidgetProps {
    onClose: () => void;
}

export const placeOrderWidget = ({ onClose }: IplaceOrderWidgetProps) => {
    return (
        <>
            <div className="box-collage-next">
                <button
                    className="boxes-btn"
                    onClick={() => {
                        onClose();
                    }}
                >
                    &lt;
                    <FormattedMessage id="Back" defaultMessage="Back" />
                </button>
                <h2>
                    <FormattedMessage
                        id="How_to_place_an_order"
                        defaultMessage="How to place an order?"
                    />
                </h2>
                <div className="row">
                    <div className="col-sm-12">
                        <div className="help-center-tabs">
                            <ul
                                className="nav nav-pills mb-3"
                                id="pills-tab"
                                role="tablist"
                            >
                                <li className="nav-item active">
                                    <a
                                        className="nav-link show"
                                        id="pills-home-tab"
                                        data-toggle="pill"
                                        href="#pills-home"
                                        role="tab"
                                        aria-controls="pills-home"
                                        aria-selected="true"
                                    >
                                        <FormattedMessage
                                            id="Stock_RIC_BTE_order"
                                            defaultMessage="Stock RIC/ BTE Order Placement"
                                        />
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link"
                                        id="pills-profile-tab"
                                        data-toggle="pill"
                                        href="#pills-profile"
                                        role="tab"
                                        aria-controls="pills-profile"
                                        aria-selected="false"
                                    >
                                        <FormattedMessage
                                            id="RIC_BTE_order_earmold_absolute_power"
                                            defaultMessage="RIC/BTE Order with Custom Earmold/ Absolute Power Order Placement"
                                        />
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a
                                        className="nav-link"
                                        id="pills-contact-tab"
                                        data-toggle="pill"
                                        href="#pills-contact"
                                        role="tab"
                                        aria-controls="pills-contact"
                                        aria-selected="false"
                                    >
                                        <FormattedMessage
                                            id="Custom_product_all_styles"
                                            defaultMessage="Custom Product Orders Placement (All Styles)"
                                        />
                                    </a>
                                </li>
                            </ul>
                            <div className="tab-content" id="pills-tabContent">
                                <div
                                    className="tab-pane fade active in"
                                    id="pills-home"
                                    role="tabpanel"
                                    aria-labelledby="pills-home-tab"
                                >
                                    <div className="col-sm-6">
                                        <h3>
                                            <FormattedMessage
                                                id="Step_by_step_guide"
                                                defaultMessage="Step by Step Guide"
                                            />
                                        </h3>
                                        <ul className="ordered-list">
                                            <li>
                                                <FormattedMessage
                                                    id="On_the_estore_homepage_shop_hearing_aids"
                                                    defaultMessage="Step 1. On the eStore home page, click on 'Shop Hearing Aids' under the 'Quick Links' section"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Click_show_filters_to_help"
                                                    defaultMessage="Step 2. Click ‘Show Filters’ to help search for the product you would like to order"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Once_you_have_found_the_product"
                                                    defaultMessage="Step 3. Once you’ve found the product you would like to order, click on the image of the device"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Next_fill_out_the_order"
                                                    defaultMessage="Step 4. Next, fill out the order form page:"
                                                />
                                                <ul className="ordered-list-sec">
                                                    <li>
                                                        <FormattedMessage
                                                            id="Select_the_color"
                                                            defaultMessage="Select the color of device you would like"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Under_is_this_for_patient"
                                                            defaultMessage="Under ‘Is this for a patient?’, select ‘No’"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Next_input_the_quality_of_hearing_aids"
                                                            defaultMessage="Next, input the quantity of hearing aids you would like to order"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="For_RIC_orders"
                                                            defaultMessage="For RIC orders:"
                                                        />
                                                        <ul className="ordered-list-sec">
                                                            <li>
                                                                <FormattedMessage
                                                                    id="Enter_receiver_information"
                                                                    defaultMessage="Enter receiver information for Select Ear, Cable Length, Gain and Quantity"
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormattedMessage
                                                                    id="Click_add_another_to_add"
                                                                    defaultMessage="Click ‘Add Another’ to add additional receivers"
                                                                />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Add_accessories_or_common_supplies"
                                                            defaultMessage="Add accessories or common supplies to your order and additional warranty to the device(s)"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Lastly_click_add_to_cart"
                                                            defaultMessage="Lastly, click ‘Add To Cart’"
                                                        />
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="A_pop-up_will_appear"
                                                    defaultMessage="Step 5. A pop-up will appear – select, ‘Proceed To Checkout’"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Review_the_order_details"
                                                    defaultMessage="Step 6. Review the order details and click, ‘Place Order’"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="You_will_receive_a_confirmation"
                                                    defaultMessage="Step 7. You will receive a confirmation that your order has been submitted, no further action is required"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-6">
                                        <h3>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </h3>
                                        <ol className="ordered-list">
                                            <li>
                                                <FormattedMessage
                                                    id="How_to_place_RIC_BTE_stock"
                                                    defaultMessage="How to place a RIC or BTE stock order"
                                                />
                                                <iframe
                                                    className="help-center-video"
                                                    src="https://bcove.video/3587uMs"
                                                    frameBorder="0"
                                                    allow="autoplay; encrypted-media"
                                                    allowFullScreen
                                                    title="video"
                                                />
                                                <FormattedMessage
                                                    id="Learn_how_to_place_RIC_BTE_stock"
                                                    defaultMessage="Learn how to place a RIC or BTE hearing aid stock order"
                                                />
                                            </li>
                                        </ol>
                                    </div>
                                </div>

                                <div
                                    className="tab-pane fade"
                                    id="pills-profile"
                                    role="tabpanel"
                                    aria-labelledby="pills-profile-tab"
                                >
                                    <div className="col-sm-6">
                                        <h3>
                                            <FormattedMessage
                                                id="Step_by_step_guide"
                                                defaultMessage="Step by Step Guide"
                                            />
                                        </h3>
                                        <ul className="ordered-list">
                                            <ul className="ordered-list">
                                                <li>
                                                    <FormattedMessage
                                                        id="On_the_estore_homepage_shop_hearing_aids"
                                                        defaultMessage="Step 1. On the eStore home page, click on 'Shop Hearing Aids' under the 'Quick Links' section"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="Click_show_filters_to_help"
                                                        defaultMessage="Step 2. Click ‘Show Filters’ to help search for the product you would like to order"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="Once_you_have_found_the_product"
                                                        defaultMessage="Step 3. Once you’ve found the product you would like to order, click on the image of the device"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="Next_fill_out_the_order"
                                                        defaultMessage="Step 4. Next, fill out the order form page:"
                                                    />
                                                    <ul className="ordered-list-sec">
                                                        <li>
                                                            <FormattedMessage
                                                                id="Select_the_device_to_order"
                                                                defaultMessage="Select the color of device you would like to order"
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Under_is_this_for_a_patient"
                                                                defaultMessage="Under ‘Is this for a patient?’, select ‘Yes’"
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Fill_out_the_patients_info"
                                                                defaultMessage="Fill out the patient’s information underneath ‘Who is it for?’ (first & last name, age range and patient #)"
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Choose_fit_options_by_selecting"
                                                                defaultMessage="Choose the fit options by selecting Binaural, Right Ear Only or Left Ear Only"
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Next_select_absolute_power_or_earmold"
                                                                defaultMessage="Next, select ‘Absolute Power’ or ‘Earmold’ and proceed to fill out the ‘Send Impressions’ section:"
                                                            />
                                                            <ul className="ordered-list-sec">
                                                                <li>
                                                                    <FormattedMessage
                                                                        id="If_selected_send_physical"
                                                                        defaultMessage="If you select 'Send Physical Impressions': the submitted order will not be started until Starkey receives the physical impressions with paperwork"
                                                                    />
                                                                </li>
                                                                <li>
                                                                    <FormattedMessage
                                                                        id="If_selected_use_digital_impressions"
                                                                        defaultMessage="If you select ‘Use Digital Impressions On File’: Enter in serial number(s) and look for a green check mark with the patient’s name – this will ensure the submitted order will be submitted directly to Starkey once completed "
                                                                    />
                                                                </li>
                                                                <li>
                                                                    <FormattedMessage
                                                                        id="If_selected_direct_ear_scan"
                                                                        defaultMessage="If you select ‘Direct Ear Scan’: Enter the package ID number from Otocloud and the order will be submitted directly to Starkey once completed"
                                                                    />
                                                                </li>
                                                                <li>
                                                                    <FormattedMessage
                                                                        id="If_selected_attach_digital_impressions"
                                                                        defaultMessage="If you select ‘Attach Digital Impressions’: Please upload a Right and/or Left Impression Image to the order and the order will be submitted directly to Starkey once completed"
                                                                    />
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Fill_out_the_audiogram"
                                                                defaultMessage="Fill out the 'Audiogram' for the patient (Thresholds needed for 500, 1k, 2k and 4k)"
                                                            />
                                                            <ul className="ordered-list-sec">
                                                                <li>
                                                                    <FormattedMessage
                                                                        id="Speech_MCL_and_UCL"
                                                                        defaultMessage="Speech MCL and UCL sections are optional"
                                                                    />
                                                                </li>
                                                            </ul>
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Make_the_necessary_selections"
                                                                defaultMessage="Make the necessary selections under ‘Customs Options’ and ‘Product Options’"
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Add_accessories_or_common_supplies_to_your_order"
                                                                defaultMessage="Add accessories or common supplies to your order and additional warranty to the device(s)"
                                                            />
                                                        </li>
                                                        <li>
                                                            <FormattedMessage
                                                                id="Lastly_add_any_special"
                                                                defaultMessage="Lastly, add any special instructions to your order and click ‘Add To Cart’"
                                                            />
                                                        </li>
                                                    </ul>
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="A_pop-up_will_appear"
                                                        defaultMessage="Step 5. A pop-up will appear – select, ‘Proceed To Checkout’"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="Review_the_order_details"
                                                        defaultMessage="Step 6. Review the order details and click, ‘Place Order’"
                                                    />
                                                </li>
                                                <li>
                                                    <FormattedMessage
                                                        id="You_will_receive_a_confirmation_long"
                                                        defaultMessage="Step 7. You will receive a confirmation that your order has been submitted, including clear instructions to send impression paperwork if needed or confirming that no further action required"
                                                    />
                                                </li>
                                            </ul>
                                        </ul>
                                    </div>
                                    <div className="col-sm-6">
                                        <h3>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </h3>
                                        <ol className="ordered-list">
                                            <li>
                                                <FormattedMessage
                                                    id="How_to_order_RIC_BTE_custom"
                                                    defaultMessage="How to order a RIC or BTE with a custom receiver"
                                                />
                                                <iframe
                                                    className="help-center-video"
                                                    src="https://bcove.video/3vqp0H7"
                                                    frameBorder="0"
                                                    allow="autoplay; encrypted-media"
                                                    allowFullScreen
                                                    title="video"
                                                />
                                                <FormattedMessage
                                                    id="Learn_how_to_order_RIC_BTE_custom"
                                                    defaultMessage="Learn how to order a RIC or BTE hearing aid with a custom receiver"
                                                />
                                            </li>
                                        </ol>
                                    </div>
                                </div>

                                <div
                                    className="tab-pane fade"
                                    id="pills-contact"
                                    role="tabpanel"
                                    aria-labelledby="pills-contact-tab"
                                >
                                    <div className="col-sm-6">
                                        <h3>
                                            <FormattedMessage
                                                id="Step_by_step_guide"
                                                defaultMessage="Step by Step Guide"
                                            />
                                        </h3>
                                        <ul className="ordered-list">
                                            <li>
                                                <FormattedMessage
                                                    id="On_the_estore_homepage_shop_hearing_aids"
                                                    defaultMessage="Step 1. On the eStore home page, click on 'Shop Hearing Aids' under the 'Quick Links' section"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Click_show_filters_to_help"
                                                    defaultMessage="Step 2. Click ‘Show Filters’ to help search for the product you would like to order"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Once_you_have_found_the_product"
                                                    defaultMessage="Step 3. Once you’ve found the product you would like to order, click on the image of the device"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Next_fill_out_the_order"
                                                    defaultMessage="Step 4. Next, fill out the order form page:"
                                                />
                                                <ul className="ordered-list-sec">
                                                    <li>
                                                        <FormattedMessage
                                                            id="Select_the_faceplate_and_shell_color"
                                                            defaultMessage="Select the Faceplate and Shell color "
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Under_is_this_for_a_patient"
                                                            defaultMessage="Under ‘Is this for a patient?’, select ‘Yes’"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Fill_out_the_patients_info"
                                                            defaultMessage="Fill out the patient’s information underneath ‘Who is it for?’ (first & last name, age range and patient #)"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Choose_fit_options_by_selecting"
                                                            defaultMessage="Choose the fit options by selecting Binaural, Right Ear Only or Left Ear Only"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Next_select_method_send_impressions"
                                                            defaultMessage="Next, select the method you would like to ‘Send Impressions’:"
                                                        />
                                                        <ul className="ordered-list-sec">
                                                            <li>
                                                                <FormattedMessage
                                                                    id="If_selected_send_physical"
                                                                    defaultMessage="If you select 'Send Physical Impressions': the submitted order will not be started until Starkey receives the physical impressions with paperwork"
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormattedMessage
                                                                    id="If_selected_use_digital_impressions"
                                                                    defaultMessage="If you select ‘Use Digital Impressions On File’: Enter in serial number(s) and look for a green check mark with the patient’s name – this will ensure the submitted order will be submitted directly to Starkey once completed "
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormattedMessage
                                                                    id="If_selected_direct_ear_scan"
                                                                    defaultMessage="If you select ‘Direct Ear Scan’: Enter the package ID number from Otocloud and the order will be submitted directly to Starkey once completed"
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormattedMessage
                                                                    id="If_selected_attach_digital_impressions"
                                                                    defaultMessage="If you select ‘Attach Digital Impressions’: Please upload a Right and/or Left Impression Image to the order and the order will be submitted directly to Starkey once completed"
                                                                />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Fill_out_the_audiogram"
                                                            defaultMessage="Fill out the 'Audiogram' for the patient (Thresholds needed for 500, 1k, 2k and 4k)"
                                                        />
                                                        <ul className="ordered-list-sec">
                                                            <li>
                                                                <FormattedMessage
                                                                    id="Speech_MCL_and_UCL"
                                                                    defaultMessage="Speech MCL and UCL sections are optional"
                                                                />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Under_manufacturer_select"
                                                            defaultMessage="Under Manufacturer Select, if you choose:"
                                                        />
                                                        <ul className="ordered-list-sec">
                                                            <li>
                                                                <FormattedMessage
                                                                    id="Yes_then_Starkey"
                                                                    defaultMessage="‘Yes’, then Starkey will choose the Gain and Vent based off of the patient audiogram provided"
                                                                />
                                                            </li>
                                                            <li>
                                                                <FormattedMessage
                                                                    id="No_then_you_will_be_prompted"
                                                                    defaultMessage="‘No’, then you will be prompted to provide the Gain and Vent size that you would like for the device(s)"
                                                                />
                                                            </li>
                                                        </ul>
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Next_make_the_necessary_selections_product_options"
                                                            defaultMessage="Next, make the necessary selections under ‘Product Options’"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Add_accessories_or_common_supplies_to_your_order"
                                                            defaultMessage="Add accessories or common supplies to your order and additional warranty to the device(s)"
                                                        />
                                                    </li>
                                                    <li>
                                                        <FormattedMessage
                                                            id="Lastly_add_any_special"
                                                            defaultMessage="Lastly, add any special instructions to your order and click ‘Add To Cart’"
                                                        />
                                                    </li>
                                                </ul>
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="A_pop-up_will_appear"
                                                    defaultMessage="Step 5. A pop-up will appear – select, ‘Proceed To Checkout’"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="Review_the_order_details"
                                                    defaultMessage="Step 6. Review the order details and click, ‘Place Order’"
                                                />
                                            </li>
                                            <li>
                                                <FormattedMessage
                                                    id="You_will_receive_a_confirmation_long"
                                                    defaultMessage="Step 7. You will receive a confirmation that your order has been submitted, including clear instructions to send impression paperwork if needed or confirming that no further action required"
                                                />
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-sm-6">
                                        <h3>
                                            <FormattedMessage
                                                id="Video_tutorial"
                                                defaultMessage="Video Tutorial"
                                            />
                                        </h3>
                                        <ol className="ordered-list">
                                            <li>
                                                <FormattedMessage
                                                    id="How_to_order_custom_hearing"
                                                    defaultMessage="How to order custom hearing aids"
                                                />
                                                <iframe
                                                    className="help-center-video"
                                                    src="https://bcove.video/3psXrZW"
                                                    frameBorder="0"
                                                    allow="autoplay; encrypted-media"
                                                    allowFullScreen
                                                    title="video"
                                                />
                                                <FormattedMessage
                                                    id="Learn_how_to_order_custom_hearing"
                                                    defaultMessage="Learn how to order custom hearing aids "
                                                />
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

const mapStateToProps = (state: RootState) => {
    return {};
};

const mapDispatchToProps = {};

const placeOrderWidgetContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(placeOrderWidget);

export default placeOrderWidgetContainer;
